var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 78,
    viewBox: "0 0 122 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45801 26.972L53.656 18.166C54.098 18.098 54.54 18.098 54.982 18.166L115.298 28.264L104.588 30.406L53.588 21.532C53.35 21.498 53.146 21.498 52.908 21.532L13.332 28.4L4.45801 26.972Z",
    fill: "#5964C6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2199 58.218L69.9419 57.81",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0202 57.878L59.4702 58.354",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3982 68.486L56.4442 62.06L105.812 69.914L105.132 30.372L53.5882 21.532C53.2142 21.464 52.8402 21.464 52.4662 21.532L13.2642 28.4",
    fill: "#3A3F74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3982 68.486L56.4442 62.06L105.812 69.914L105.132 30.372L53.5882 21.532C53.2142 21.464 52.8402 21.464 52.4662 21.532L13.2642 28.4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3178 70.934L53.1798 67.296L86.7378 73.586L85.9558 33.942V33.908L66.5078 29.828C66.2358 29.794 65.9978 29.794 65.7258 29.828L44.2378 33.976L30.5698 70.662C30.5698 70.662 31.3178 70.866 31.3518 70.866L31.3178 70.934Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7842 55.804L52.5342 67.194",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2638 34.962L68.1738 37.444C66.5418 37.75 64.9438 37.784 63.2778 37.444L49.7798 34.996L64.8758 31.936C65.3518 31.834 65.8618 31.834 66.3378 31.936L81.2638 34.962Z",
    fill: "#5964C6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9482 58.252L66.7122 59.272C66.0662 59.408 65.3862 59.408 64.7402 59.272L59.3682 58.354L65.4202 57.096C65.6242 57.062 65.7942 57.062 65.9982 57.096L72.0842 58.252",
    fill: "#3A3F74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9482 58.252L66.7122 59.272C66.0662 59.408 65.3862 59.408 64.7402 59.272L59.3682 58.354L65.4202 57.096C65.6242 57.062 65.7942 57.062 65.9982 57.096L72.0842 58.252",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9219 29.522L44.8159 34.146L65.7259 30.202C65.9299 30.168 66.0319 30.168 66.2359 30.202L86.0579 34.078L96.8359 31.902L51.8199 23.81C51.1399 23.674 50.4599 23.674 49.7799 23.81L17.9899 29.522H17.9219Z",
    fill: "#5964C6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3662 38.362V40.3L103.092 39.246L98.3662 38.362Z",
    fill: "#5964C6",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6925 37.954L50.3925 35.03C49.1345 34.792 47.9785 35.744 47.9785 37.002V53.628C47.9785 54.614 48.6925 55.43 49.6445 55.6L65.6925 58.558L81.4685 55.6C82.3185 55.43 82.9645 54.682 82.9645 53.798V36.798C82.9645 35.642 81.9105 34.758 80.7545 34.996L65.6585 37.92L65.6925 37.954Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8962 59.374L71.7782 58.252C72.4922 58.116 73.1382 58.66 73.1382 59.374V74.878C73.1382 75.422 72.7302 75.898 72.1862 76C72.1522 76 72.1522 76 72.1182 76C72.0502 76 71.9822 76.034 71.9142 76.034C71.8122 76.068 71.7102 76.068 71.6082 76.102C71.4722 76.136 71.3362 76.136 71.2342 76.17C71.0982 76.204 70.9282 76.238 70.7922 76.238C70.6222 76.272 70.4522 76.306 70.2822 76.34C70.1122 76.374 69.9082 76.408 69.7382 76.442C69.5342 76.476 69.3642 76.51 69.1602 76.544C68.9562 76.578 68.7862 76.612 68.5822 76.646C68.3782 76.68 68.2082 76.714 68.0042 76.748C67.8342 76.782 67.6642 76.816 67.4602 76.85C67.2902 76.884 67.1202 76.918 66.9842 76.952C66.8482 76.986 66.7122 76.986 66.5762 77.02C66.3042 77.054 66.0662 77.122 65.7942 77.156C65.4542 77.156 65.1482 77.088 64.8082 77.054C64.6722 77.02 64.5362 77.02 64.4342 76.986C64.2982 76.952 64.1282 76.918 63.9922 76.918C63.8222 76.884 63.6522 76.85 63.4822 76.816C63.3122 76.782 63.1422 76.748 62.9382 76.714C62.7682 76.68 62.5642 76.646 62.3942 76.612C62.2242 76.578 62.0202 76.544 61.8502 76.51C61.6802 76.476 61.5102 76.442 61.3062 76.408C61.1362 76.374 60.9662 76.34 60.7962 76.306C60.6602 76.272 60.4902 76.238 60.3542 76.238C60.2182 76.204 60.0822 76.204 59.9802 76.17C59.8782 76.136 59.7762 76.136 59.6742 76.102C59.6062 76.102 59.5382 76.068 59.4702 76.068C59.4362 76.068 59.4022 76.068 59.3682 76.034C58.8242 75.932 58.4502 75.456 58.4502 74.912V59.51C58.4502 58.796 59.0962 58.252 59.8102 58.388L65.4542 59.408C65.5902 59.374 65.7602 59.374 65.8962 59.374Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3664 63.012V69.88C98.3664 70.73 97.7545 71.478 96.9385 71.648L87.2485 73.586C86.1265 73.79 85.1064 72.974 85.1064 71.818V35.506C85.1064 34.758 85.6505 34.112 86.3985 33.942L96.4964 31.936C97.4824 31.732 98.4004 32.48 98.4004 33.5V40.368L103.126 39.314V61.822L98.4004 63.012H98.3664Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.67 31.902V68.214C103.67 69.336 104.69 70.186 105.778 69.948L115.502 68.01C116.318 67.84 116.93 67.126 116.93 66.276V29.93C116.93 28.876 115.978 28.094 114.958 28.298L104.996 30.304C104.214 30.44 103.67 31.12 103.67 31.902Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8283 29.624L24.0763 55.906C24.2123 56.28 24.2123 56.722 24.0763 57.13L20.1323 67.126C19.5883 68.894 17.0723 68.928 16.4603 67.194L2.9623 29.522C2.4863 28.094 3.7103 26.7 5.1723 27.006L13.3663 28.366C14.0123 28.502 14.5903 28.978 14.8283 29.624Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6924 37.954V58.558",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6924 59.408V77.088",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2964 29.556L44.7144 34.18C45.8704 34.384 46.3124 36.628 45.4964 38.294L32.9164 69.778C32.2704 71.376 29.9924 71.342 29.4144 69.71L16.7324 33.568C15.8144 31.018 16.8684 29.318 18.2964 29.556Z",
    fill: "#F26241",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9785 37.716H66.5425L65.6585 37.92L64.9785 37.716Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1062 35.268C85.2422 33.874 84.0522 33.67 84.0522 33.67L86.0243 34.044C86.0243 34.044 85.5483 34.18 85.3783 34.52C85.1403 34.996 85.1062 35.2 85.1062 35.2",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1062 35.268C85.2422 33.874 84.0522 33.67 84.0522 33.67L86.0243 34.044C86.0243 34.044 85.5483 34.18 85.3783 34.52C85.1403 34.996 85.1062 35.2 85.1062 35.2",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.67 12.896L118.596 12.556L116.658 12.93L118.732 13.236L120.67 12.896Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.658 12.93V15.208V15.242L118.732 15.548V13.236L116.658 12.93Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.732 15.548V13.236L120.67 12.896V15.208L118.732 15.548Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.364 13.372L120.806 13.236",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.364 13.61H120.84",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.916 13.61L118.358 14.29",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.746 13.814L118.052 14.256",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M103.636 31.868C103.636 30.372 102.514 29.964 102.514 29.964L104.656 30.304C104.656 30.304 104.146 30.508 103.908 30.882C103.602 31.392 103.704 31.936 103.704 31.936",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6924 41.184C65.6924 37.954 68.4464 37.41 68.4464 37.41L65.7264 37.954V41.184H65.6924Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.692 41.184C65.692 37.954 62.938 37.41 62.938 37.41L65.658 37.954V41.184H65.692Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9761 23.912C53.0101 21.464 54.6421 21.702 54.6421 21.702L53.0101 21.498L52.9761 23.912C52.9761 23.946 52.9761 23.946 52.9761 23.912Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9761 23.912C53.0101 21.464 54.6421 21.702 54.6421 21.702L53.0101 21.498L52.9761 23.912ZM52.9761 23.912C52.9761 23.946 52.9761 23.946 52.9761 23.912Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9764 23.98C52.9424 21.464 51.2764 21.736 51.2764 21.736L52.9424 21.532V23.98H52.9764Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.896 31.766C65.93 30.236 67.664 30.474 67.664 30.474L65.93 30.236L65.896 31.766Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8962 31.8C65.8622 30.27 64.0942 30.508 64.0942 30.508L65.8622 30.236L65.8962 31.766V31.8Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3662 66.854C98.3662 63.08 100.814 62.4 100.814 62.4L98.3662 63.08V66.854Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6924 62.196C65.6924 59.408 68.0044 59 68.0044 59L65.7264 59.476L65.6924 62.196Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6924 62.196C65.6924 59.408 63.3804 59 63.3804 59L65.6584 59.476L65.6924 62.196Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1343 71.274C83.2845 71.274 83.4063 71.1218 83.4063 70.934C83.4063 70.7462 83.2845 70.594 83.1343 70.594C82.9841 70.594 82.8623 70.7462 82.8623 70.934C82.8623 71.1218 82.9841 71.274 83.1343 71.274Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.834 29.998C16.9842 29.998 17.106 29.8458 17.106 29.658C17.106 29.4702 16.9842 29.318 16.834 29.318C16.6838 29.318 16.562 29.4702 16.562 29.658C16.562 29.8458 16.6838 29.998 16.834 29.998Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0303 67.262C54.1805 67.262 54.3023 67.1098 54.3023 66.922C54.3023 66.7343 54.1805 66.582 54.0303 66.582C53.8801 66.582 53.7583 66.7343 53.7583 66.922C53.7583 67.1098 53.8801 67.262 54.0303 67.262Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2061 66.752C22.3563 66.752 22.4781 66.5998 22.4781 66.412C22.4781 66.2242 22.3563 66.072 22.2061 66.072C22.0559 66.072 21.9341 66.2242 21.9341 66.412C21.9341 66.5998 22.0559 66.752 22.2061 66.752Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2622 69.37C35.4125 69.37 35.5342 69.2178 35.5342 69.03C35.5342 68.8422 35.4125 68.69 35.2622 68.69C35.112 68.69 34.9902 68.8422 34.9902 69.03C34.9902 69.2178 35.112 69.37 35.2622 69.37Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M101.834 67.806C101.984 67.806 102.106 67.6538 102.106 67.466C102.106 67.2782 101.984 67.126 101.834 67.126C101.684 67.126 101.562 67.2782 101.562 67.466C101.562 67.6538 101.684 67.806 101.834 67.806Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.766 32.14C101.916 32.14 102.038 31.9878 102.038 31.8C102.038 31.6122 101.916 31.46 101.766 31.46C101.616 31.46 101.494 31.6122 101.494 31.8C101.494 31.9878 101.616 32.14 101.766 32.14Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6783 35.914C83.8285 35.914 83.9503 35.7618 83.9503 35.574C83.9503 35.3862 83.8285 35.234 83.6783 35.234C83.528 35.234 83.4062 35.3862 83.4062 35.574C83.4062 35.7618 83.528 35.914 83.6783 35.914Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7403 36.254C47.8905 36.254 48.0123 36.1018 48.0123 35.914C48.0123 35.7262 47.8905 35.574 47.7403 35.574C47.59 35.574 47.4683 35.7262 47.4683 35.914C47.4683 36.1018 47.59 36.254 47.7403 36.254Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1402 67.262C51.2904 67.262 51.4122 67.1098 51.4122 66.922C51.4122 66.7343 51.2904 66.582 51.1402 66.582C50.9899 66.582 50.8682 66.7343 50.8682 66.922C50.8682 67.1098 50.9899 67.262 51.1402 67.262Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M65.896 30.27V31.8",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9761 21.532V23.98",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15809 65.732V63.352L4.45809 62.978H4.28809V65.12C4.28809 65.12 4.28809 65.494 4.90009 65.596C5.51209 65.698 6.15809 65.732 6.15809 65.732Z",
    fill: "#F26241"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15828 65.732V63.284L7.99428 62.944V64.95C7.99428 64.95 8.19828 65.528 7.31428 65.63C6.43028 65.732 6.12428 65.732 6.15828 65.732Z",
    fill: "#89422F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50616 56.28L1.16016 62.434L6.15816 63.284L6.22616 56.722",
    fill: "#8ED943"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50616 56.28L1.16016 62.434L6.15816 63.284L6.22616 56.722",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1582 63.284L11.5982 62.264L9.0142 56.212L6.2262 56.722",
    fill: "#04BF8A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1582 63.284L11.5982 62.264L9.0142 56.212L6.2262 56.722",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32227 62.978V65.188C4.32227 65.46 5.13826 65.698 6.15826 65.698C7.17826 65.698 7.99426 65.46 7.99426 65.188V63.012",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22607 47.916L9.93207 56.042L6.22607 56.722",
    fill: "#04BF8A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22607 47.916L9.93207 56.042L6.22607 56.722",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22638 56.722L2.58838 56.144L6.22638 47.916",
    fill: "#8ED943"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22638 56.722L2.58838 56.144L6.22638 47.916",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2262 56.654L6.1582 63.284",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22607 56.722V47.916",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38232 52.812L7.79032 53.118",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 53.322L7.99394 53.628",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09619 57.504L8.47019 57.81",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26611 58.014L8.67411 58.32",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2681 19.288V20.24L34.1061 24.014C34.1061 24.014 34.9221 27.244 35.0241 27.788C35.1261 28.332 35.0241 29.08 35.0241 29.08C35.0241 29.386 34.1401 29.624 33.0861 29.624C32.0321 29.624 31.1481 29.386 31.1481 29.08C31.1481 29.08 31.6241 27.38 31.8961 26.7C32.1681 26.02 32.1001 24.218 32.1001 24.218L28.1561 22.076L27.9521 20.988L29.7541 20.648L29.9241 21.634L32.1681 23.164",
    fill: "#F26241"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4321 18.948L37.2681 19.288V20.24L34.1061 24.014L34.2081 24.456C30.8081 23.742 30.0601 21.77 30.0601 21.77L31.8281 22.892L33.2221 22.45L35.4661 19.9V18.948H35.4321Z",
    fill: "#89422F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1701 10.822V18.506L38.6621 19.526V11.808L44.1701 10.822Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6443 15.582V20.104L27.3403 21.09V16.534L32.6443 15.582Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3402 21.09L20.4722 19.866V15.31L27.3402 16.568V21.09Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6442 15.548L25.7762 14.324L20.4722 15.276L27.3402 16.568L32.6442 15.548Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2681 19.288V20.24L34.1061 24.014C34.1061 24.014 34.9221 27.244 35.0241 27.788C35.1261 28.332 35.0241 29.08 35.0241 29.08C35.0241 29.386 34.1401 29.624 33.0861 29.624C32.0321 29.624 31.1481 29.386 31.1481 29.08C31.1481 29.08 31.6241 27.38 31.8961 26.7C32.1681 26.02 32.1001 24.218 32.1001 24.218L28.1561 22.076L27.9521 20.988L29.7541 20.648L29.9241 21.634L32.0661 23.13",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7603 22.926L33.0523 22.552L35.4323 19.866V18.948",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9181 14.596L27.5781 15.582C27.5781 15.582 26.9321 15.718 26.6941 15.582C26.0821 15.208 25.5381 14.426 25.5381 14.426",
    fill: "#F26241"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9181 14.596L27.5781 15.582C27.5781 15.582 26.9321 15.718 26.6941 15.582C26.0821 15.208 25.5381 14.426 25.5381 14.426",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5441 15.378L27.8161 14.596L27.1021 14.766L25.9121 14.528",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3403 9.36002V14.732L33.6643 13.508V8.13602L32.3383 8.37402L27.3403 9.36002Z",
    fill: "#04BF8A",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3403 14.732L20.5063 13.508V8.13602L27.3403 9.36002V14.732Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5063 8.13602L26.8303 6.87802L33.6644 8.13602L27.3403 9.36002L20.5063 8.13602Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6622 19.526L31.5562 18.234V10.55L38.6622 11.808V19.526Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5562 10.55L37.0642 9.53003L44.1702 10.822L38.6622 11.808L31.5562 10.55Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0641 20.41L37.2681 20.24V19.288L35.4321 18.948V19.39",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M29.958 21.736L29.89 21.668L29.72 20.648L28.768 20.818L27.918 20.988",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 9.53003C22.002 9.53003 22.002 9.83603 22.274 10.142",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.73 10.074C21.73 10.074 21.73 10.38 22.002 10.686",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7563 15.48C41.7563 15.48 41.7563 15.684 41.9603 15.922",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5522 15.854C41.5522 15.854 41.5522 16.058 41.7562 16.296",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4321 15.174C35.4321 15.174 35.4321 15.48 35.7041 15.786",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1602 15.718C35.1602 15.718 35.1602 16.024 35.4322 16.33",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1304 19.356C25.1304 19.356 25.1304 19.492 25.2664 19.662",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.184 19.152C26.184 19.152 26.184 19.356 26.082 19.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6401 19.22C25.6401 19.22 25.6401 19.526 25.6401 19.832",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4302 9.66602C40.4302 9.66602 40.1582 10.21 40.1582 10.516",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0781 14.528C36.0781 14.528 36.2141 15.31 36.2141 15.752",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7842 9.76804C39.7842 9.76804 39.7842 10.074 39.7842 10.38",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9984 29.896C14.9984 29.896 14.3524 28.196 16.2904 27.958L13.4004 28.434C13.4004 28.434 14.3524 28.57 14.7944 29.59",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M45.972 35.914C45.972 35.914 45.734 34.214 47.366 33.738L44.748 34.112C44.748 34.112 45.768 34.248 45.972 35.914Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2142 68.282L21.5262 67.84C19.8262 68.18 20.3362 66.718 20.3362 66.718C20.3362 66.718 19.8942 68.01 19.1802 68.282H19.2142Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1001 70.798L34.4121 70.322C32.7461 70.73 33.2561 69.166 33.2561 69.166C33.2561 69.166 32.7801 70.526 32.1001 70.798Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0921 73.45L83.1001 72.872C84.8681 73.212 85.0381 71.784 85.0381 71.784C85.0381 71.784 85.0721 72.872 86.0921 73.45Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M104.69 69.914L101.868 69.234C103.636 69.574 103.602 68.146 103.602 68.146C103.602 68.146 103.704 69.302 104.69 69.914Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7538 70.492V58.694L78.3398 58.252V70.05L80.7538 70.492Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M80.754 58.694C75.518 65.086 79.904 70.288 79.904 70.288L80.754 70.458C80.754 70.458 76.946 65.052 80.754 59.612V58.694Z",
    fill: "#FFD148",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M80.754 60.292C76.368 65.256 80.754 70.22 80.754 70.22V69.268C80.754 69.268 77.592 65.426 80.754 61.21V60.292Z",
    fill: "#39E1DD",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M116.964 16.704L113.836 16.194L110.878 16.738L114.006 17.248L116.964 16.704Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M110.878 16.738V20.206V20.24L114.006 20.716V17.248L110.878 16.738Z",
    fill: "#8ED943",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M114.006 20.682V17.248L116.964 16.704V20.172L114.006 20.716",
    fill: "#04BF8A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M114.006 20.682V17.248L116.964 16.704V20.172L114.006 20.716",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M116.522 17.418L117.168 17.248",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M116.522 17.758H117.236",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M112.816 17.758L113.462 18.812",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M112.578 18.098L112.986 18.778",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0922 73.28V71.376L50.7322 71.07H50.5962V72.804C50.5962 72.804 50.5962 73.11 51.0722 73.178C51.5482 73.246 52.0582 73.28 52.0582 73.28",
    fill: "#F26241"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0923 73.28V71.308L53.5883 71.036V72.634C53.5883 72.634 53.7243 73.076 53.0443 73.178C52.3643 73.28 52.0923 73.28 52.0923 73.28Z",
    fill: "#89422F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9841 65.766L48.0801 70.662L52.0921 71.342L52.1601 66.106",
    fill: "#8ED943"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9841 65.766L48.0801 70.662L52.0921 71.342L52.1601 66.106",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0923 71.342L56.4443 70.526L54.3703 65.698L52.1603 66.106",
    fill: "#04BF8A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0923 71.342L56.4443 70.526L54.3703 65.698L52.1603 66.106",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6299 71.104V72.872C50.6299 73.11 51.2759 73.28 52.1259 73.28C52.9759 73.28 53.6219 73.11 53.6219 72.872V71.138",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1602 59.068L55.0842 65.562L52.1602 66.106",
    fill: "#04BF8A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1602 59.068L55.0842 65.562L52.1602 66.106",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1598 66.106L49.2358 65.63L52.1598 59.068",
    fill: "#8ED943"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1598 66.106L49.2358 65.63L52.1598 59.068",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1603 66.038L52.0923 71.342",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1602 66.106V59.068",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0781 62.978L53.3841 63.216",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M53.248 63.386L53.554 63.658",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6221 66.718L53.9281 66.956",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M53.792 67.16L54.098 67.398",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5242 72.056V70.594L42.4702 70.356H42.3682V71.682C42.3682 71.682 42.3682 71.92 42.7422 71.988C43.1162 72.056 43.5242 72.056 43.5242 72.056Z",
    fill: "#F26241"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5244 72.056V70.56L44.6804 70.356V71.58C44.6804 71.58 44.7824 71.92 44.2724 71.988C43.7624 72.056 43.5584 72.056 43.5244 72.056Z",
    fill: "#89422F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9264 66.276L40.4644 70.016L43.5244 70.56L43.5924 66.514",
    fill: "#8ED943"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9264 66.276L40.4644 70.016L43.5244 70.56L43.5924 66.514",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5244 70.56L46.8904 69.948L45.2924 66.208L43.5924 66.514",
    fill: "#04BF8A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5244 70.56L46.8904 69.948L45.2924 66.208L43.5924 66.514",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4023 70.39V71.75C42.4023 71.92 42.9123 72.056 43.5583 72.056C44.2043 72.056 44.7143 71.92 44.7143 71.75V70.424",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5923 61.142L45.8703 66.106L43.5923 66.514",
    fill: "#04BF8A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5923 61.142L45.8703 66.106L43.5923 66.514",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5921 66.514L41.3481 66.174L43.5921 61.142",
    fill: "#8ED943"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5921 66.514L41.3481 66.174L43.5921 61.142",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5924 66.48L43.5244 70.56",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5923 66.514V61.142",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3062 64.134L44.5442 64.304",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4082 64.44L44.6462 64.644",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7144 67.024L44.9524 67.194",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8506 67.33L45.0886 67.534",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4247 32.3405C40.8702 32.2723 41.2037 32.0364 41.1696 31.8137C41.1355 31.591 40.7467 31.4657 40.3012 31.5339C39.8558 31.602 39.5223 31.8379 39.5564 32.0606C39.5905 32.2834 39.9792 32.4087 40.4247 32.3405Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M45.462 31.392L60.932 28.502L53.452 27.346L39.376 30.44L45.462 31.392Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2598 31.868L40.5658 31.902",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5078 27.5467C60.8827 27.5238 61.1772 27.3533 61.1658 27.1658C61.1543 26.9784 60.8411 26.8451 60.4663 26.868C60.0915 26.8909 59.7969 27.0614 59.8084 27.2489C59.8198 27.4363 60.133 27.5696 60.5078 27.5467Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.9999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M60.354 27.108L60.694 27.21",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3882 27.244L60.6942 27.108",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4521 29.828C53.4861 27.074 55.4921 27.38 55.4921 27.38L53.4861 27.108V29.862C53.4521 29.862 53.4521 29.862 53.4521 29.862V29.828Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3837 29.828C53.3837 27.074 51.9897 27.38 51.9897 27.38L53.3497 27.108V29.862L53.3837 29.828Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M60.286 28.57C49.916 23.708 42.062 30.814 42.062 30.814L43.49 31.052C43.49 31.052 50.358 25.578 58.926 28.842L60.252 28.604L60.286 28.57Z",
    fill: "#FFD148",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57.804 29.08C49.644 24.864 43.728 31.086 43.728 31.086L44.85 31.29C44.85 31.29 49.814 26.496 56.546 29.318L57.804 29.08Z",
    fill: "#39E1DD",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6043 73.722V72.464L46.7203 72.26H46.6523V73.382C46.6523 73.382 46.6523 73.586 46.9583 73.62C47.2643 73.654 47.6043 73.688 47.6043 73.722Z",
    fill: "#F26241"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6045 73.722V72.43L48.5905 72.26V73.314C48.5905 73.314 48.6925 73.62 48.2505 73.654C47.8085 73.688 47.6385 73.722 47.6045 73.722Z",
    fill: "#89422F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2103 68.758L44.9863 71.988L47.6043 72.43L47.6383 68.996",
    fill: "#8ED943"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2103 68.758L44.9863 71.988L47.6043 72.43L47.6383 68.996",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6045 72.43L50.4945 71.92L49.1345 68.724L47.6385 68.996",
    fill: "#04BF8A"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6045 72.43L50.4945 71.92L49.1345 68.724L47.6385 68.996",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6523 72.294V73.45C46.6523 73.586 47.0943 73.722 47.6383 73.722C48.1823 73.722 48.6243 73.586 48.6243 73.45V72.294",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 64.372L49.6102 68.622L47.6382 68.996",
    fill: "#04BF8A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 64.372L49.6102 68.622L47.6382 68.996",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6384 68.996L45.7344 68.69L47.6384 64.372",
    fill: "#8ED943"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6384 68.996L45.7344 68.69L47.6384 64.372",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6385 68.962L47.6045 72.43",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 68.996V64.372",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2505 66.922L48.4545 67.092",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3525 67.194L48.5565 67.364",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6245 69.404L48.8285 69.574",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7266 69.676L48.9306 69.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4661 24.762V22.45L84.9021 22.076H84.7661V24.184C84.7661 24.184 84.7661 24.558 85.3101 24.66C85.8541 24.762 86.4661 24.796 86.4661 24.762Z",
    fill: "#F26241"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4663 24.762V22.382L88.1663 22.042V23.98C88.1663 23.98 88.3363 24.524 87.5543 24.626C86.7723 24.728 86.4663 24.728 86.4663 24.728V24.762Z",
    fill: "#89422F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0183 15.616L81.8423 21.566L86.4663 22.382L86.5343 16.024",
    fill: "#8ED943"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0183 15.616L81.8423 21.566L86.4663 22.382L86.5343 16.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4663 22.382L91.5323 21.43L89.1183 15.548L86.5343 16.024",
    fill: "#04BF8A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4663 22.382L91.5323 21.43L89.1183 15.548L86.5343 16.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7661 22.11V24.252C84.7661 24.524 85.5481 24.762 86.4661 24.762C87.3841 24.762 88.1661 24.524 88.1661 24.252V22.144",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5342 7.49002L89.9682 15.378L86.5342 16.024",
    fill: "#04BF8A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5342 7.49002L89.9682 15.378L86.5342 16.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5345 16.024L83.1685 15.48L86.5345 7.49002",
    fill: "#8ED943"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5345 16.024L83.1685 15.48L86.5345 7.49002",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5343 15.956L86.4663 22.382",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5342 16.024V7.49002",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6221 12.25L87.9961 12.522",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7925 12.76L88.1665 13.032",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2681 16.806L88.6081 17.078",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4385 17.316L88.8125 17.588",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1421 24.728V23.028L78.9521 22.756H78.8501V24.286C78.8501 24.286 78.8501 24.558 79.2581 24.626C79.6661 24.694 80.1421 24.728 80.1421 24.728Z",
    fill: "#F26241"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1421 24.728V22.994L81.4681 22.756V24.184C81.4681 24.184 81.6041 24.592 80.9921 24.66C80.3801 24.728 80.1421 24.728 80.1421 24.728Z",
    fill: "#89422F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2383 17.996L76.5723 22.382L80.1423 22.96L80.2103 18.302",
    fill: "#8ED943"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2383 17.996L76.5723 22.382L80.1423 22.96L80.2103 18.302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1421 22.96L84.0181 22.246L82.1821 17.928L80.2101 18.302",
    fill: "#04BF8A"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1421 22.96L84.0181 22.246L82.1821 17.928L80.2101 18.302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8164 22.756V24.354C78.8164 24.558 79.3944 24.728 80.1424 24.728C80.8904 24.728 81.4684 24.558 81.4684 24.354V22.79",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2104 12.046L82.8285 17.826L80.2104 18.302",
    fill: "#04BF8A"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2104 12.046L82.8285 17.826L80.2104 18.302",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2105 18.302L77.6265 17.894L80.2105 12.046",
    fill: "#8ED943"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2105 18.302L77.6265 17.894L80.2105 12.046",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2101 18.268L80.1421 22.96",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2104 18.302V12.046",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0264 15.514L81.2984 15.752",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1621 15.888L81.4341 16.126",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5024 18.846L81.8084 19.084",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6382 19.22L81.9442 19.458",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1782 26.87V25.408L91.1582 25.17H91.0562V26.496C91.0562 26.496 91.0562 26.734 91.4302 26.802C91.8042 26.87 92.1782 26.87 92.1782 26.87Z",
    fill: "#F26241"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1782 26.87V25.374L93.3002 25.17V26.394C93.3002 26.394 93.4022 26.734 92.8922 26.802C92.3822 26.87 92.1782 26.87 92.1782 26.87Z",
    fill: "#89422F"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5802 21.124L89.1182 24.864L92.1782 25.374L92.2462 21.362",
    fill: "#8ED943"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5802 21.124L89.1182 24.864L92.1782 25.374L92.2462 21.362",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1782 25.374L95.5102 24.762L93.9462 21.056L92.2462 21.362",
    fill: "#04BF8A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1782 25.374L95.5102 24.762L93.9462 21.056L92.2462 21.362",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0562 25.204V26.53C91.0562 26.7 91.5662 26.836 92.1782 26.836C92.7902 26.836 93.3002 26.7 93.3002 26.53V25.204",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2461 16.024L94.4901 20.954L92.2461 21.362",
    fill: "#04BF8A"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2461 16.024L94.4901 20.954L92.2461 21.362",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M92.246 21.362L90.002 21.022L92.246 16.024",
    fill: "#8ED943"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M92.246 21.362L90.002 21.022L92.246 16.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2462 21.328L92.1782 25.374",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2461 21.362V16.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9263 19.016L93.1643 19.186",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M93.062 19.322L93.3 19.492",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3682 21.872L93.6062 22.042",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4702 22.178L93.7082 22.382",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1364 15.854C61.1364 15.48 61.2724 15.038 61.4084 14.63C61.6124 13.95 62.0204 13.372 62.4964 12.828C63.4144 11.808 63.8904 10.04 63.8224 8.61201C63.6864 6.16401 61.6464 4.12401 59.1984 4.05601C56.4444 3.95401 53.9624 6.36801 53.9624 9.12201C53.9624 11.91 54.6084 12.114 55.5944 13.236C55.9344 13.678 56.2064 14.154 56.3764 14.664C56.5124 15.038 56.5804 15.378 56.5804 15.65",
    fill: "#FFD148"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1364 15.854C61.1364 15.48 61.2724 15.038 61.4084 14.63C61.6124 13.95 62.0204 13.372 62.4964 12.828C63.4144 11.808 63.8904 10.04 63.8224 8.61201C63.6864 6.16401 61.6464 4.12401 59.1984 4.05601C56.4444 3.95401 53.9624 6.36801 53.9624 9.12201C53.9624 11.91 54.6084 12.114 55.5944 13.236C55.9344 13.678 56.2064 14.154 56.3764 14.664C56.5124 15.038 56.5804 15.378 56.5804 15.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0564 15.208C57.0564 14.97 56.9884 14.664 56.8864 14.324C56.7164 13.848 56.4784 13.406 56.1724 13.032C54.8804 11.4 54.8804 10.584 54.8804 9.25802C54.8804 6.84402 56.8524 4.73602 59.3004 4.73602C59.4024 4.73602 59.7764 4.73603 59.9464 4.80403H60.1164L60.3544 4.90602C57.8384 4.80402 55.6624 6.94602 55.6624 9.36002C55.6624 11.774 55.6624 11.468 56.9544 13.066C57.2604 13.44 57.5324 13.882 57.6684 14.358C57.7704 14.664 57.8724 15.004 57.8384 15.208",
    fill: "#FAEFCD"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1724 15.65V18.812V18.846L59.0284 19.288V16.092L56.1724 15.65Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0283 19.254V16.092L61.7143 15.582V18.778L59.0283 19.288",
    fill: "#3A3F74"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0283 19.254V16.092L61.7143 15.582V18.778L59.0283 19.288",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4302 19.05V19.798H57.4642L59.0622 20.07V19.288L57.4302 19.05Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0625 20.07V19.288L60.5585 19.016V19.764L59.0625 20.07Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3824 18.54L56.8184 18.234",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3824 18.2L56.8184 17.894",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6401 18.54L61.2381 18.234",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6401 18.2L61.2381 17.894",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7144 15.582L58.8584 15.14L56.1724 15.65L59.0284 16.092L61.7144 15.582Z",
    fill: "#FFD148",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3141 15.446C58.1101 14.63 57.9061 13.848 57.6681 13.066C57.5661 12.726 57.4981 12.42 57.4301 12.08C57.3281 11.706 57.1921 11.264 57.1921 10.856C57.1921 10.584 57.2601 10.312 57.4981 10.176C57.7701 10.006 58.0421 10.108 58.2121 10.346C58.3821 10.584 58.6201 10.788 58.7561 11.06C58.8241 11.23 58.8241 11.4 58.6201 11.434C58.5181 11.434 58.3481 11.434 58.2461 11.332C58.1101 11.196 58.1781 10.924 58.2461 10.754C58.4161 10.38 58.7561 9.90402 59.1981 9.97202C59.6401 10.04 59.8441 10.652 59.7421 11.06C59.7421 11.23 59.5721 11.468 59.4021 11.264C59.2661 11.094 59.5721 10.856 59.7081 10.754C59.8781 10.618 60.1161 10.482 60.3541 10.482C60.5921 10.482 60.6601 10.584 60.6601 10.822C60.6601 11.468 60.3201 12.114 60.1501 12.726C59.8781 13.644 59.6741 14.562 59.6061 15.514C59.6061 15.616 59.7761 15.616 59.7761 15.514C59.8781 14.46 60.1161 13.406 60.4221 12.386C60.5581 12.012 60.6941 11.604 60.7621 11.196C60.7961 10.958 60.8981 10.584 60.7281 10.38C60.5921 10.244 60.3201 10.244 60.1161 10.312C59.8441 10.38 59.5381 10.584 59.3341 10.822C59.1981 10.992 59.1301 11.23 59.3341 11.4C59.5381 11.57 59.7421 11.502 59.8441 11.264C60.0821 10.822 59.8781 10.142 59.4701 9.90402C58.9261 9.56402 58.4501 10.006 58.1781 10.448C58.0421 10.652 57.9061 10.924 57.9741 11.196C58.0081 11.468 58.2461 11.57 58.5181 11.604C58.8921 11.604 59.0281 11.298 58.8921 10.992C58.8241 10.822 58.6881 10.686 58.5521 10.55C58.4161 10.38 58.2801 10.176 58.1101 10.04C57.7021 9.73401 57.1581 10.006 57.0221 10.448C56.9201 10.754 56.9881 11.06 57.0221 11.366C57.0901 11.638 57.1581 11.91 57.1921 12.148C57.4641 13.27 57.7701 14.358 58.0761 15.48C58.0761 15.582 58.2801 15.548 58.2461 15.446H58.3141Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9604 2.49202V1.13202",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8843 2.93403L62.3263 1.64203",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8223 4.49801L64.8763 3.64801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0983 4.49801L53.0103 3.64801",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2064 3.07003L55.5264 1.91403",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f5d30c7eeb0e188da3754c1f0550d73.svg";
export { ForwardRef as ReactComponent };